import React from 'react';
import { Box, ChevronDownIcon, ChevronUpIcon, RadioButton } from '@common-fe/common-fe';

interface Props {
  testId?: string;
  isSelected?: boolean;
  isExpanded?: boolean;
  onSelect?: () => void;
  onToggleExpand?: () => void;
}

const CheckCardSelector: React.FC<Props> = ({
  testId, isSelected, isExpanded, onSelect, onToggleExpand,
}) => (
  <Box direction="row" margin={{ vertical: 'spacing8', right: 'spacing12' }}>
    <RadioButton
      data-testid={`${testId}_radio-button`}
      name={`${testId}_radio-button`}
      checked={isSelected}
      onChange={onSelect}
    />

    <Box
      width={{ min: 'spacing24' }}
      height={{ min: 'spacing24' }}
      margin={{ left: 'spacing12' }}
      onClick={onToggleExpand}
    >
      {isExpanded ? (
        <ChevronUpIcon size="spacing24" color="iconPrimary" />
      ) : (
        <ChevronDownIcon size="spacing24" color="iconPrimary" />
      )}
    </Box>
  </Box>
);

export default CheckCardSelector;
